import { render, staticRenderFns } from "./SingleProjectTask.vue?vue&type=template&id=1b4d7164&scoped=true&"
import script from "./SingleProjectTask.vue?vue&type=script&lang=js&"
export * from "./SingleProjectTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4d7164",
  null
  
)

export default component.exports